// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3h0md","content":"Alert_content__32es8","info":"Alert_info__1lFrK","icon":"Alert_icon__2pUHA","success":"Alert_success__1_24a","error":"Alert_error__3cgyz"};